import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://leafalchemy-api.onrender.com";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// attach admin token
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("la_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const asArray = (value) => (Array.isArray(value) ? value : []);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Static contact info (also fetchable from API)
export const LOCATION = {
  name: "Leaf Alchemy",
  mapsUrl: "https://www.google.com/maps/place/17%C2%B018'12.8%22N+78%C2%B031'40.7%22E/@17.303559,78.527969,17z/data=!3m1!4b1!4m4!3m3!8m2!3d17.303559!4d78.527969?entry=ttu&g_ep=EgoyMDI2MDgxOS4wIKXMDSoASAFQAw%3D%3D",
  embedUrl: "https://www.google.com/maps?q=17.303559,78.527969&z=17&output=embed",
  plusCode: "8G3H+C5H",
  locality: "Hyderabad",
  region: "Telangana",
  country: "India",
  address: "8G3H+C5H, Hyderabad, Telangana, India",
  displayAddress: "17°18'12.8\"N 78°31'40.7\"E • 8G3H+C5H, Hyderabad, Telangana, India",
  coordinates: { latitude: 17.303559, longitude: 78.527969 },
};

export const CONTACT = {
  brand: "Leaf Alchemy",
  poc: "Yashwanth Kumar Tirunagari",
  phone: "+91 99122 26145",
  phoneRaw: "+919912226145",
  email: "hello@leafalchemy.shop",
  whatsapp: "919912226145",
  socials: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    threads: "https://threads.net",
    linkedin: "https://linkedin.com",
    youtube: "https://youtube.com",
  },
  location: LOCATION,
};

export const whatsappLink = (msg = "Hi Leaf Alchemy, I'm interested in your tea powder.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;
